import { gql } from "apollo-boost"

export const createValoration = gql`
mutation CreateValoration($data: CreateValorationInput!) {
  CreateValoration(data: $data)
}`